import { Observable } from 'rxjs';
import { fetchTranslations } from 'utils/api/queries/wcm';
export class TranslationServices {
	public static fetchTranslations(language: string): Observable<types.appConfig.labels> {
		return fetchTranslations(language).call();
	}
}

export default TranslationServices;
